<template>
    <div>
        <h4>{{data.module_id > 0 ? ($lang('Indywidualne ustawienia dla modułu:') + ' ') : ''}}{{ data.module_name }}</h4>
        <table class="table simple-table table-striped table-sm small">
            <thead class="thead-dark">
            <tr>
                <th>
                    <label class="m-0">{{ $lang('Kryterium') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Od') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Do') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Dni wolne') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Czas realizacji') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Jednostka czasu') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Czas reakcji [%]') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Czas zagrożenia [%]') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Czas obejścia [%]') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Wydłużenie terminu [dni]') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Autozamknięcie [dni]') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Włączone') }}</label>
                </th>
                <th>
                    <label class="m-0">{{ $lang('Akcje') }}</label>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(sla, index) in data.data">
                <td :data-title="$lang('Kryterium')"><span>{{ sla.criterion_name }}</span></td>
                <td :data-title="$lang('Od')" :colspan="sla.sla_full_day ? 2 : 1">
                    <span>{{ sla.sla_full_day ? $lang('całodobowo') : sla.sla_from }}</span></td>
                <td :data-title="$lang('Do')" v-if="!sla.sla_full_day"><span>{{ sla.sla_to }}</span></td>
                <td :data-title="$lang('Dni wolne')"><span>{{ sla.sla_everyday ? $lang('TAK') : $lang('NIE') }}</span>
                </td>
                <td :data-title="$lang('Czas realizacji')">{{ sla.number_of_unit }}</td>
                <td :data-title="$lang('Jednostka czasu')">{{
                        sla.unit === 'hours' ? $lang('godziny') : $lang('dni')
                    }}
                </td>
                <td :data-title="$lang('Czas reakcji [%]')">{{ sla.reaction_percentage > 0 ? sla.reaction_percentage : '-' }}</td>
                <td :data-title="$lang('Czas zagrożenia [%]')">{{ sla.warning_percentage > 0 ? sla.warning_percentage : '-' }}</td>
                <td :data-title="$lang('Czas obejścia [%]')">{{ sla.workaround_percentage > 0 ? sla.workaround_percentage : '-'}}</td>
                <td :data-title="$lang('Wydłużenie terminu [dni]')">{{ sla.workaround_deadline_extend > 0 ? sla.workaround_deadline_extend : '-' }}</td>
                <td :data-title="$lang('Autozamknięcie [dni]')">{{ sla.auto_close_days > 0 ? sla.auto_close_days : '-' }}</td>
                <td :data-title="$lang('Włączone')">
                    <span v-if="sla.enable" class="badge badge-success">{{ $lang('TAK') }}</span>
                    <span v-else class="badge badge-danger">{{ $lang('NIE') }}</span>
                </td>
                <td :data-title="$lang('Akcje')"><a href="#" @click.prevent="openModal(index)">{{ $lang('Edycja') }}</a>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="modal fade" id="modal_edit_sla" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Edycja konfiguracji SLA') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="itemInModalIndex !== null">
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <dl>
                                    <dt>{{$lang('Produkt')}}:</dt>
                                    <dd>{{dataEditable[itemInModalIndex].product_system_name}}</dd>
                                </dl>
                            </div>
                            <div class="col-12 col-md-4" v-if="dataEditable[itemInModalIndex].module_name !== null">
                                <dl>
                                    <dt>{{$lang('Moduł')}}:</dt>
                                    <dd>{{dataEditable[itemInModalIndex].module_name}}</dd>
                                </dl>
                            </div>
                            <div class="col-12 col-md-4">
                                <dl>
                                    <dt>{{$lang('Kryterium')}}:</dt>
                                    <dd>{{dataEditable[itemInModalIndex].criterion_name}}</dd>
                                </dl>
                            </div>
                            <div class="col-12 py-0"><hr class="my-2"></div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group mb-0">
                                    <input type="checkbox" id="enable" name="enable"
                                           v-model="dataEditable[itemInModalIndex].enable">
                                    <label for="enable">{{ $lang('Włączone') }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group mb-0">
                                    <input type="checkbox" id="sla_everyday" name="sla_everyday"
                                           v-model="dataEditable[itemInModalIndex].sla_everyday">
                                    <label for="sla_everyday">{{ $lang('Dostępność w dni wolne') }}</label>
                                    <input type="checkbox" id="sla_full_day" name="sla_full_day" class="ml-4"
                                           v-model="dataEditable[itemInModalIndex].sla_full_day">
                                    <label for="sla_full_day">{{ $lang('Całodobowo') }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="!dataEditable[itemInModalIndex].sla_full_day">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <datepicker-accessible
                                        :disable="dataEditable[itemInModalIndex].sla_full_day"
                                        :label-single="$lang('Okno świadczenia usług (początek)')"
                                        custom-id="sla_from"
                                        name="sla_from"
                                        mode="time"
                                        :use_pencil_checkbox="false"
                                        :is_required="false"
                                        v-model="dataEditable[itemInModalIndex].sla_from"
                                    ></datepicker-accessible>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <datepicker-accessible
                                        :disable="dataEditable[itemInModalIndex].sla_full_day"
                                        :label-single="$lang('Okno świadczenia usług (koniec)')"
                                        custom-id="sla_to"
                                        name="sla_to"
                                        mode="time"
                                        :use_pencil_checkbox="false"
                                        :is_required="false"
                                        v-model="dataEditable[itemInModalIndex].sla_to"
                                    ></datepicker-accessible>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="number_of_unit">{{ $lang('Czas rozwiązania/naprawy') }}</label>
                                    <input class="form-control" type="number" id="number_of_unit" name="number_of_unit"
                                           v-model="dataEditable[itemInModalIndex].number_of_unit">

                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="unit">{{ $lang('Jednostka czasu') }}</label>
                                    <select class="form-control" id="unit"
                                            v-model="dataEditable[itemInModalIndex].unit">
                                        <option value="days">{{ $lang('Dni') }}</option>
                                        <option value="hours">{{ $lang('Godziny') }}</option>
                                    </select>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-9">
                                <div class="form-group">
                                    <div class="range-labels">
                                        <label class="m-0 small" for="">{{ $lang('Data zgłoszenia') }}</label>
                                        <label class="m-0 small font-weight-bold"
                                               for="reaction_percentage">{{ $lang('Czas reakcji') }}</label>
                                        <label class="m-0 small pull-right" for="">
                                            {{ $lang('Termin realizacji') }}</label>

                                    </div>
                                    <input
                                           v-model="dataEditable[itemInModalIndex].reaction_percentage" type="range"
                                           min="0" max="100" step=".1" class="slider" id="reaction_percentage">
                                </div>

                            </div>
                            <div class="col-12 col-md-3">
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-prepend mt-2">
                                            <div class="bg-icon"><i class="fa fa-percent" aria-hidden="true"></i></div>
                                        </div>
                                        <input class="form-control mt-2" type="number" max="100"
                                               @blur="maxControl(itemInModalIndex, 'reaction_percentage')"
                                               id="reaction_percentage_i"
                                               name="reaction_percentage_i"
                                               v-model="dataEditable[itemInModalIndex].reaction_percentage">
                                    </div>

                                </div>
                            </div>
                            <div class="col-12 col-md-9">
                                <div class="form-group">
                                    <div class="range-labels">
                                        <label class="m-0 small" for="">{{ $lang('Data zgłoszenia') }}</label>
                                        <label class="m-0 small font-weight-bold"
                                               for="warning_percentage">{{ $lang('Czas zagrożenia') }}</label>
                                        <label class="m-0 small pull-right" for="">
                                            {{ $lang('Termin realizacji') }}</label>

                                    </div>
                                    <input
                                           v-model="dataEditable[itemInModalIndex].warning_percentage" type="range"
                                           min="0" max="100" step=".1" class="slider" id="warning_percentage">
                                </div>

                            </div>
                            <div class="col-12 col-md-3">
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-prepend mt-2">
                                            <div class="bg-icon"><i class="fa fa-percent" aria-hidden="true"></i></div>
                                        </div>
                                        <input class="form-control mt-2" type="number" max="100"
                                               @blur="maxControl(itemInModalIndex, 'warning_percentage')"
                                               id="warning_percentage_i"
                                               name="warning_percentage_i"
                                               v-model="dataEditable[itemInModalIndex].warning_percentage">
                                    </div>

                                </div>
                            </div>
                            <div class="col-12 col-md-9">
                                <div class="form-group">
                                    <div class="range-labels">
                                        <label class="m-0 small" for="">{{ $lang('Data zgłoszenia') }}</label>
                                        <label class="m-0 small font-weight-bold"
                                               for="workaround_percentage">{{ $lang('Czas obejścia') }}</label>
                                        <label class="m-0 small pull-right" for="">
                                            {{ $lang('Termin realizacji') }}
                                        </label>

                                    </div>
                                    <input
                                           v-model="dataEditable[itemInModalIndex].workaround_percentage" type="range"
                                           min="0" max="100" step=".1" class="slider" id="workaround_percentage">
                                </div>

                            </div>
                            <div class="col-12 col-md-3">
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-prepend mt-2">
                                            <div class="bg-icon"><i class="fa fa-percent" aria-hidden="true"></i></div>
                                        </div>
                                        <input class="form-control mt-2" type="number" max="100"
                                               @blur="maxControl(itemInModalIndex, 'workaround_percentage')"
                                               id="workaround_percentage_i"
                                               name="workaround_percentage_i"
                                               v-model="dataEditable[itemInModalIndex].workaround_percentage">
                                    </div>

                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="workaround_deadline_extend">{{ $lang('Wydłużenie terminu realizacji z tytułu rozwiązania tymczasowego (dni)') }}</label>
                                    <input class="form-control" type="number" id="workaround_deadline_extend" name="workaround_deadline_extend"
                                           v-model="dataEditable[itemInModalIndex].workaround_deadline_extend">

                                </div>
                            </div>
                            <div class="col-12 py-0"><hr class="my-2"></div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="auto_close_days">{{ $lang('Autozamknięcie (dni)') }}</label>
                                    <input class="form-control" type="number" id="auto_close_days" name="auto_close_days"
                                           v-model="dataEditable[itemInModalIndex].auto_close_days">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click.prevent="cancel" class="btn btn-default" data-dismiss="modal">{{
                                $lang('Zamknij')
                            }}
                        </button>
                        <button id="choose-criterion" @click.prevent="saveConfig" type="button" class="btn btn-primary">
                            {{ $lang('Zapisz') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";
import {EventBus} from "../../mixins/event-bus";

export default {
    name: "sla-table",
    mixins: [ShowNotification],
    props: {
        data: {
            type: Object,
            required: true
        },
        saveUrl: {
            type: String,
            required: true
        },
        productSystemId: {
            type: Number,
            required: true
        },
        moduleId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            itemInModalIndex: null,
            dataEditable: {}
        }
    },
    methods: {
        openModal(index) {
            this.itemInModalIndex = index;
            this.dataEditable = JSON.parse(JSON.stringify(this.data.data));
            $('#modal_edit_sla').modal('show');
        },
        saveConfig() {
            let self = this;
            axios.post(self.saveUrl, {
                     module_id: self.moduleId,
                     product_system_id: self.productSystemId,
                     config: self.dataEditable,
                 })
                 .then(function (response) {
                     EventBus.$emit('refreshSlaTable', {});
                     $('#modal_edit_sla').modal('hide');
                     self.showNotification('success', self.$lang('Zapisano!'));
                 })
                 .catch((error) => {
                     self.showNotification('error', self.$lang('Wystąpił błąd podczas zapisu!'));
                     console.log(error.response);
                 });
        },
        cancel() {

        },
        maxControl(index, property) {
            if (parseInt(this.dataEditable[index][property]) > 100) {
                this.dataEditable[index][property] = 100;
            }
        }
    },
    created() {
        this.dataEditable = JSON.parse(JSON.stringify(this.data.data));
    },
}
</script>


<style scoped>
.slider {
    -webkit-appearance: none;
    width: 100%;
    height: 10px;
    border-radius: 5px;
    background: #ddd;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
}

.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    /*border-radius: 50%;*/
    background: var(--primary-to-yellow);
    cursor: pointer;
}

.slider::-moz-range-thumb {
    width: 18px;
    height: 18px;
    /*border-radius: 50%;*/
    background: var(--primary-to-yellow);
    cursor: pointer;
}

.range-labels {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
</style>
